export const ALLOWANCE_RULES = {
  PETS_ALLOWED: 'pets-allowed',
  OVERNIGHT_GUESTS_ALLOWED: 'overnight-guests-allowed'
};
